<template>
  <span>
    <template v-if="statusData">
      <status-badge
        v-if="fullText"
        class="mr-2"
        :color="statusData.color"
      >{{statusData.titleMessage}}</status-badge>
      <v-icon
        v-else
        :color="statusData.color"
        :title="statusData.titleMessage"
      >{{ statusData.icon }}</v-icon>
    </template>

    <template v-else-if="surveyDisabled">
      <status-badge
        v-if="fullText"
        class="mr-2"
        color="#BBB"
      >{{ this.trans('survey.statusNoSurvey') }}</status-badge>
      <v-icon
        v-else
        color="#BBB"
        :title="this.trans('survey.statusNoSurvey')"
      >mdi-clipboard-off</v-icon>
    </template>
  </span>
</template>

<script>

import {LocaleUtils} from '@/utils/locale-utils';
import StatusBadge from '@/components/StatusBadge';
import {SurveyUtils} from '../utils/survey-utils';

export default {
  name: 'SurveyStatus',
  components: {
    StatusBadge
  },
  mixins: [
    LocaleUtils,
    SurveyUtils
  ],
  props: {
    booking: {
      type: Object,
      required: true
    },
    surveyResult: {
      default: null
    },
    fullText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    surveyDisabled () {
      return !this._isSurveyActivated(this.booking);
    },
    surveyResultInternal () {
      return this.surveyResult || this.booking?.surveyResult;
    },
    statusData () {
      let status = {
        icon: 'mdi-clipboard-clock',
        color: 'pending',
        titleMessage: this.trans('survey.statusSurveyMissing')
      };

      if(this.surveyResultInternal != null) {
        switch (this.surveyResultInternal.status) {
          case 'SENT':
            status.titleMessage = this.trans('survey.statusSurveySent');
            status.icon = 'mdi-clipboard-play';
            status.color = 'success';
            break;
          case 'OPENED':
            status.titleMessage = this.trans('survey.statusSurveyOpened');
            status.icon = 'mdi-clipboard-search';
            status.color = 'success';
            break;
          case 'ANSWERED':
            status.titleMessage = this.trans('survey.statusSurveyReplied');
            status.icon = 'mdi-clipboard-edit';
            status.color = 'success';
            break;
          case 'REVIEWED':
            status.titleMessage = this.trans('survey.statusSurveyReviewed');
            status.icon = 'mdi-clipboard-check';
            status.color = 'success darken-1';
            break;
        }
      }

      return (this.surveyResultInternal != null || !this.surveyDisabled) ? status : null;
    }
  },
}
</script>
